const BatchSidebar = (props: { isOpen: boolean; onToggle: (open: boolean) => void }) => {
  void props
  return null
}

export default BatchSidebar
